module.exports = __webpack_public_path__ + "static/img/logo-wight.1ef7fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-wight.png
// module id = 3n4h
// module chunks = 1